import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md px-6 text-center"
      >
        <div className="w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mx-auto mb-6">
          <X className="w-8 h-8 text-white/30" />
        </div>
        <h1 className="text-3xl font-light text-white/95 mb-3" data-testid="payment-cancel-title">Payment Cancelled</h1>
        <p className="text-white/40 text-sm mb-8">No charges were made. You can try again anytime.</p>
        <div className="space-y-3">
          <Link to="/pricing">
            <Button className="w-full bg-white/10 text-white/80 hover:bg-white/15 border border-white/10 rounded-full h-11 text-sm" data-testid="cancel-pricing-btn">
              View Plans
            </Button>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="w-full text-white/40 hover:text-white text-sm" data-testid="cancel-home-btn">
              Return Home
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
